
<template>
  <div>
    <el-dialog
      center
      :visible.sync="payVisible"
      width="500px"
      :show-close="false"
      :close-on-click-modal="false"
    >
      <div>
        <div style="width: 100%" class="LR_center">
          <div>
            <p class="dialog-l-tit">充值金额</p>
          </div>
          <el-tooltip placement="bottom">
            <div class="countText" slot="content">
              活动规则:
              <br />
              <p>
                1、如何充值？用户完成在货代拼平台（https://www.huodaipin.com）、
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;h5“货代拼”公众号等注册后，在平台页面选择固定金额支付后，获得固定充值金额。
              </p>
<!--              <p>2、规则说明：其中充1元送50元活动仅限新用户首次充值仅限一次（限量500份）其他金额在活动期间内不限制充值次数。</p>-->
              <!-- <p>2、只支持固定金额返现，区间充值不支持返现；</p> -->
              <p>2、充值金额与返现金额不限制有效期，适用于平台产生的各项费用。</p>
              <p>
                3、参与企业若存在相关子公司，仅限一家参加充值活动，如同一IP、
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                同一支付账号或其他合理显示为同一公司的情形，均视为同一用户，
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                活动过程中，任何活动参与方存在虚假交易、恶意套利、作弊等不诚信行为，
                <br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                货代拼将有权利取消活动及参与活动的资格，并保留依法追踪法律责任的权利。
              </p>
              <p>4、活动最终解释权归货代拼所有。</p>
            </div>
            <el-button size="mini" class="el-icon-question">活动规则</el-button>
          </el-tooltip>
        </div>
        <ul class="flex justify-between align-center flex-wrap pay-list">
          <!-- <li
            v-for="(item, i) in amountList"
            :style="i > 1 ? {} : { width: '188px' }" -->
          <li
            v-for="(item, i) in amountList"
            :style="{ width: '188px' }"
            :key="item.amonut"
            class="pay-list-item"
            :class="isActive === item.amount ? 'is-active' : ''"
            @click="handleCheck(item.amount)"
          >
            <!-- <div v-if="i == 0" class="HotWrap">
              <span class="Hot">Hot</span>
            </div> -->

            <div>
              <p
                class="pay-value"
                :class="item.gift ? '' : 'no-give'"
              >{{ item.amount | NumFormatFloat }}元</p>
              <p v-if="item.gift" class="gift-count">赠送{{ item.gift }}元</p>
              <span class="check" v-if="isActive === item.amount">
                <el-icon name="check"></el-icon>
              </span>
            </div>
          </li>
          <!-- <template v-if="amountList.length > 2">
            <li
              v-for="(item, i) in Array(3 -(amountList.length-2)%3).fill(1)"
              :key="`test_${i}`"
              class="pay-list-item is-placeholder"
            >
            </li>
          </template> -->
        </ul>
        <div class="oth-wrap" :class="!isActive ? 'is-active' : ''">
          <input class="oth-inp" v-model="payForm.amountInp" placeholder="其它金额(元）" size="normal">
          <!-- <p class="gift-count">赠送{{slftGift}}元</p> -->
          <p class="gift-count">赠送充值金额的2%</p>
          <p class="error-tip" v-if="errorTip">{{errorTip}}</p>
          <span class="check" v-if="!isActive">
            <el-icon name="check"></el-icon>
          </span>
        </div>
      </div>
      <div style="margin-top: 25px">
        <p class="dialog-l-tit">支付方式</p>
        <div>
          <el-radio-group style="margin-top: 10px" v-model="payForm.payType" @change="typeChange">
            <el-radio
              class="radio-wrap"
              :class="payForm.payType === 'WECHAT' ? 'active' : ''"
              label="WECHAT"
            >
              <img
                style="margin-right: 10px; width: 20px; vertical-align: middle"
                src="@images/we-chatpay.png"
                alt="微信"
              />
              微信
              <span class="check" v-if="payForm.payType === 'WECHAT'">
                <el-icon name="check"></el-icon>
              </span>
            </el-radio>
            <el-radio
              class="radio-wrap"
              :class="payForm.payType === 'ALIPAY' ? 'active' : ''"
              label="ALIPAY"
            >
              <img
                style="margin-right: 10px; width: 20px; vertical-align: middle"
                src="@images/alipay.png"
                alt="支付宝"
              />
              支付宝
              <span class="check" v-if="payForm.payType === 'ALIPAY'">
                <el-icon name="check"></el-icon>
              </span>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer">
        <el-button style="width: 100%; margin: 0; height: 50px" type="primary" @click="toPay">去付款</el-button>
        <el-button
          class="cancel-button"
          style="width: 100%; margin: 0; margin-top: 20px"
          @click="
            isActive = 1;
            payForm = { payType: 'WECHAT' };
            handleClose();
          "
        >取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="loading-pay"
      :modal-append-to-body="false"
      title="提示"
      center
      :visible.sync="loading"
      width="380px"
      top="38vh"
      :close-on-click-modal="false"
      @close="stopLoading"
    >
      <span slot="title" class="dialog-l-tit"></span>
      <p style="margin-top: -10px; font-size: 16px">提示</p>
      <div style="margin-top: 20px; line-height: 24px">
        <p align="center">等待支付，请扫码支付</p>
      </div>
      <span slot="footer">
        <el-button type="primary" size="mini" @click="stopLoading">放弃支付</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="wechat-pay"
      :modal-append-to-body="false"
      title="微信支付"
      :visible.sync="qrCodeVisible"
      width="480px"
      :close-on-click-modal="false"
      @close="
        qrCodeVisible = false;
        $emit('show');
      "
    >
      <span slot="title" class="dialog-l-tit">微信支付</span>
      <div class="flex align-center justify-between" style="font-size: 14px; line-height: 25px">
        <div class="qr-wrap">
          <div v-if="qrCodeVisible" id="qrcode"></div>
        </div>
        <div style="width: 150px">
          <div>
            <p>
              <label>交易金额:</label>
              <label>￥ {{ resultAmount.amount | NumFormatFloat }}</label>
            </p>
            <p>
              <label>赠送金额:</label>
              <label>￥ {{ resultAmount.giveAmount }}</label>
            </p>
            <p>
              <label>实际到账:</label>
              <label>￥ {{ resultAmount.realAmount | NumFormatFloat }}</label>
            </p>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px; line-height: 24px">
        <p>温馨提示：</p>
        <p style>不支持信用卡方式支付，如有未结清费用，充值后自动抵扣，充值后请及时核对充值数据。</p>
      </div>
      <span slot="footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2"
import { isObject } from "@/assets/js/utils"

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      qrCodeVisible: false,
      payForm: {
        payType: "WECHAT",
      },
      stopCheck: false,
      isActive: 2000,
      activeInfo: [],
      slftGift: "0",
      resultAmount: {
        amount: "0",
        giveAmount: "0",
        realAmount: "0",
      },
      hisIsActive: 1,
      loading: false,
      errorTip: "",
    }
  },
  computed: {
    payVisible () {
      return this.visible
    },
    amountList () {
      const list = [
        // { amount: 1000, gift: 0 },
        // { amount: 3000, gift: 0 },
        // { amount: 5000, gift: 0 },
        // { amount: 10000, gift: 0 },
        // { amount: 30000, gift: 0 },
        // { amount: 50000, gift: 0 }
        // { amount: 0.01, gift: 0 },
        // { amount: 2000, gift: 0 },
        { amount: 5000, gift: 0 },
        { amount: 10000, gift: 0 },
        { amount: 30000, gift: 0 },
        { amount: 50000, gift: 0 }
      ]
      list.map((v) => {
        console.log(this.activeInfo)
        const item = this.activeInfo.filter((el) => {
          return v.amount > el.startNumber && v.amount <= el.endNumber
        })
        if (this.activeInfo.length) {
          if (item.length) {
            const index = this.activeInfo.length - 1
            v.gift = Math.floor((v.amount * item[0].giftPercent) / 100)
            // v.gift = v.gift > this.activeInfo[index].limitMax ? this.activeInfo[index].limitMax : v.gift
            v.gift =
              v.gift > this.activeInfo[index].limitMax &&
                this.activeInfo[index].limitMax
                ? this.activeInfo[index].limitMax
                : v.gift
          } else {
            const index = this.activeInfo.length - 1
            // v.gift = this.activeInfo[index].limitMax ? this.activeInfo[index].limitMax : v.gift = Math.floor(v.amount * this.activeInfo[index].giftPercent / 100)
            // v.gift = this.activeInfo[index].limitMax
            v.gift = 0
          }
        }
      })
      return list
    },
  },
  watch: {
    isActive (val) {
      if (val) {
        this.hisIsActive = val
      }
    },
    "payForm.amountInp": {
      deep: true,
      handler (val, oldVal) {
        if (
          val &&
          !/^\d*(\.|\d+)$/.test(val) &&
          !/^\d*\.?[\d]{0,2}$/.test(val)
        ) {
          this.$set(this.payForm, "amountInp", oldVal)
        } else if (val && /^\./.test(val)) {
          this.$set(this.payForm, "amountInp", oldVal)
        // } else if (Number(val) > 1000000) {
        //   this.$set(this.payForm, "amountInp", oldVal)
        } else if (Number(val) > 50000) {
          this.$set(this.payForm, "amountInp", 50000)
        }
        if (Number(val) > 0) {
          this.errorTip = ""
          this.isActive = null
          const item = this.activeInfo.filter((el) => {
            return val > el.startNumber && val <= el.endNumber
          })
          if (this.activeInfo.length) {
            this.slftGift = Math.floor((val * item[0].giftPercent) / 100)
            // if (item.length) {
            //   const index = this.activeInfo.length - 1
            //   const slftGift = Math.floor((val * item[0].giftPercent) / 100)
            //   // this.slftGift = slftGift > this.activeInfo[index].limitMax ? this.activeInfo[index].limitMax : slftGift
            //   // this.slftGift = slftGift > this.activeInfo[index].limitMax && this.activeInfo[index].limitMax ? this.activeInfo[index].limitMax : slftGift
            //   this.slftGift =
            //     slftGift > this.activeInfo[index].limitMax &&
            //       this.activeInfo[index].limitMax
            //       ? this.activeInfo[index].limitMax
            //       : slftGift
            // } else {
            //   const index = this.activeInfo.length - 1
            //   // this.slftGift = this.activeInfo[index].limitMax
            //   // this.slftGift = this.activeInfo[index].limitMax ? this.activeInfo[index].limitMax : Math.floor(val * this.activeInfo[index].giftPercent / 100)
            //   this.slftGift = 0
            // }
          } else {
            this.slftGift = 0
            this.isActive = this.hisIsActive
          }
        } else if (!val) {
          this.errorTip = ""
          this.slftGift = 0
          this.isActive = this.hisIsActive
        } else if (val && /^\./.test(val)) {
          this.slftGift = 0
          this.isActive = this.hisIsActive
        } else if (val === "0" || Number(val) === 0) {
          this.slftGift = 0
          this.isActive = null
        }
      },
    },
  },
  mounted () {
    this.getActive()
  },
  methods: {
    stopLoading () {
      this.loading = false
      this.stopCheck = true
    },
    getActive () {
      // /activity/findActivityNow
      this.axios.post("/activity/findActivityNow").then((res) => {
        if (!isObject(res.data)) return false
        // if (res.data.code === 0) return false
        if (!isObject(res.data.data)) return false
        // giftPercent
        // startNumber
        // endNumber
        // res.data.data.list.forEach(v => {
        //   // this.activeInfo[`${v.startNumber}-${v.endNumber}`] = v.giftPercent
        //   this.activeInfo[`${v.startNumber}-${v.endNumber}`] = v.giftPercent
        // })
        this.activeInfo = res.data.data.list || []
      })
    },
    wxPay (amount) {
      // /onlinepay/createNativePreOrder
      let user = this.sessionGetUserInfo()
      const data = {
        amount,
        paidWeChatPayAmount: amount * 100,
        payType: "WECHAT",
        customerId: user.customerid,
        customerCode: user.customerCode,
      }
      this.axios.post("/onlinepay/createNativePreOrder", data).then((res) => {
        if (res.data.code === 200) {
          this.qrCodeVisible = true
          this.handleClose()
          this.code = res.qrcodeUrl
          setTimeout(() => {
            const response = res.data.data
            const qrcode = new QRCode("qrcode", {
              width: 176,
              height: 176,
              text: response.qrcodeUrl, // 二维码地址
              colorDark: "#000",
              colorLight: "#fff",
            })
            this.stopCheck = false
            this.checkWechatpayRes(response)
          }, 200)
        } else {
          this.$notify({
            title: "提示",
            message: res.data.message,
            type: "warning",
          })
        }
      })
    },
    aliPay (amount) {
      // /onlinepay/createAliWebPayPreOrder
      let user = this.sessionGetUserInfo()
      const data = {
        amount,
        paidAlPayAmount: amount,
        payType: "ALIPAY",
        customerId: user.customerid,
        customerCode: user.customerCode,
      }
      this.axios
        .post("/onlinepay/createAliWebPayPreOrder", data)
        .then((res) => {
          if (res.data.code === 200) {
            // this.qrCodeVisible = true
            // this.code = res.qrcodeUrl
            // setTimeout(() => {
            //   const response = res.data.data
            //   const qrcode = new QRCode('qrcode', {
            //     width: 176,
            //     height: 176,
            //     text: response.qrcodeUrl, // 二维码地址
            //     colorDark: '#000',
            //     colorLight: '#fff'
            //   })
            //   this.stopCheck = false
            //   this.checkWechatpayRes(response)
            // }, 200)
            const response = res.data.data
            this.payLoading(response)
            window.open(response.webUrl)
          } else {
            this.$notify({
              title: "提示",
              message: res.data.message || "支付异常，请稍后重试",
              type: "warning",
            })
          }
        })
    },
    checkWechatpayRes (res) {
      const data = {
        nonceStr: res.nonceStr,
        outTradeNo: res.outTradeNo,
        payType: "WECHAT",
      }
      this.axios
        .post("/onlinepay/findWeChatNativePayOrder", data)
        .then((response) => {
          const resp = response.data.data
          if (resp.trade_state === "NOTPAY" || resp.trade_state === "ACCEPT") {
            setTimeout(() => {
              if (!this.stopCheck) this.checkWechatpayRes(res)
            }, 1000)
          } else {
            switch (resp.trade_state) {
              case "SUCCESS":
                this.qrCodeVisible = false
                this.$notify({
                  title: "成功",
                  message: "交易支付成功",
                  type: "success",
                })
                setTimeout(() => {
                  this.handleClose()
                  this.$set(this.payForm, "amountInp", "")
                  this.$emit("amountChange")
                }, 0)
                break
              default:
                this.$notify({
                  title: "warning",
                  message: "支付失败请重新支付",
                  type: "success",
                })
                break
            }
          }
        })
    },
    payLoading (res) {
      this.loading = true
      // this.loading = this.$loading({
      //   lock: true,
      //   text: '等待支付…',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // setTimeout(() => {
      //   this.stopCheck = true
      //   // this.loading.close()
      //   this.loading = false
      //   this.$notify({
      //     title: 'warning',
      //     message: '未付款交易超时关闭，或支付完成后全额退款',
      //     type: 'success'
      //   })
      // }, 5*60*1000)
      this.stopCheck = false
      this.checkAlipayRes(res)
    },
    checkAlipayRes (res) {
      // /onlinepay/findAliFacePayOrder
      const data = {
        nonceStr: res.nonce_str,
        outTradeNo: res.outTradeNo,
        payType: "ALIPAY",
      }
      this.axios.post("/onlinepay/findAliFacePayOrder", data).then((resp) => {
        if (resp.data.code === 200) {
          const response = resp.data.data
          if (response.tradeStatus === "WAIT_BUYER_PAY") {
            setTimeout(() => {
              if (!this.stopCheck) this.checkAlipayRes(res)
            }, 1000)
          } else {
            // this.loading.close()
            this.loading = false
            switch (response.tradeStatus) {
              case "TRADE_SUCCESS":
                this.$notify({
                  title: "成功",
                  message: "交易支付成功",
                  type: "success",
                })
                this.handleClose()
                this.$set(this.payForm, "amountInp", "")
                this.$emit("amountChange")
                break
              default:
                break
            }
          }
        } else {
          // this.loading.close()
          this.loading = false
          this.$message.error(resp.data.message)
        }
      })
    },
    handleAmountChange (val) {
      if (val && Number(val) > 0) {
        this.isActive = null
      }
    },
    handleCheck (val) {
      this.isActive = val
      this.$set(this.payForm, "amountInp", "")
    },
    typeChange (val) {
      if (val === "") {
        this.$set(this.payForm, "amountInp", "")
      }
    },
    handleClose () {
      this.$emit("close")
    },
    toPay () {
      if (!this.payForm.amountInp && !this.isActive) {
        this.$message.warning("请选择或输入充值金额")
        return
      }
      if (this.payForm.amountInp < 5000 && !this.isActive) {
        this.errorTip = "输入金额未达到5000元以上"
        return
      }
      if (!Number(this.payForm.amountInp) && !this.isActive) {
        this.errorTip = "请输入大于0的金额"
        return
      }
      this.stopCheck = true
      if (this.payForm.payType === "WECHAT") {
        // this.qrCodeVisible = true
        const amount = this.isActive
          ? this.isActive
          : Number(this.payForm.amountInp)
        const giveAmount = this.isActive
          ? this.amountList.filter((v) => this.isActive === v.amount)[0].gift
          : this.slftGift
        this.resultAmount = {
          amount,
          giveAmount,
          realAmount: Number(amount) + Number(giveAmount),
        }
        this.wxPay(amount)
      } else {
        const amount = this.isActive
          ? this.isActive
          : Number(this.payForm.amountInp)
        this.aliPay(amount)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.countText {
  font-size: 18px;
  line-height: 30px;
}
.flex {
  display: flex;
  &.align-center {
    align-items: center;
  }
  &.justify-between {
    justify-content: space-between;
  }
  &.justify-around {
    justify-content: space-around;
  }
  &.flex-wrap {
    flex-wrap: wrap;
  }
}
.pay-list {
  .pay-list-item {
    position: relative;
    margin-top: 20px;
    width: 24%;
    padding: 10px;
    text-align: center;
    // line-height: 25px;
    line-height: 50px;
    border: 1px solid #dcdcdc;
    color: #bcbcbc;
    cursor: pointer;
    transition: all 0.2s;
    border-radius: 5px;
    height: 50px;
    overflow: hidden;
    &.is-placeholder{
      border-color: transparent;
      cursor: inherit;
    }
    &:not(.is-placeholder){
      &:hover {
        border-color: #f9c158;
        transform: scale(1.06);
        box-shadow: 0 0 8px rgba($color: #666666, $alpha: 0.2);
      }
    }

    .pay-value {
      font-size: 16px;
      &.no-give {
        line-height: 50px;
      }
    }
    .HotWrap {
      position: absolute;
      width: 25px;
      height: 69px;
      transform: rotate(-50deg);
      top: -28px;
      right: 1px;
      background-color: #ff685d;
      padding: 0;
      .Hot {
        position: absolute;
        top: 25px;
        right: 3px;
        font-size: 13px;
        color: #f9c158;
        transform: rotate(50deg);
      }
    }
    .check {
      position: absolute;
      width: 0;
      height: 0;
      right: 0;
      bottom: 0;
      border: 14px solid #f9c158;
      border-top-color: transparent;
      border-left-color: transparent;
      border-right-width: 14px;
      .el-icon-check {
        position: absolute;
        bottom: -10px;
        color: #fff;
        font-size: 12px;
      }
    }
    &.is-active {
      border-color: #f9c158;
      color: #f9c158;
      .gift-count {
        color: #FFFFFF;
        background: #f9c158;
      }
    }
  }
}
.gift-count {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 5px;
  line-height: 22px;
  color: #f9c158;
  background: #ffeac4;
  border-radius: 0 0 5px 0;
}
.radio-wrap {
  width: 166px;
  margin-bottom: 10px;
  padding: 10px 20px;
  border: 1px solid #ededed;
  transition: all 0.3s;
  text-align: center;
  border-radius: 5px;
  .check {
    position: absolute;
    width: 0;
    height: 0;
    right: 0;
    bottom: 0;
    border: 14px solid #f9c158;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-width: 14px;
    .el-icon-check {
      position: absolute;
      bottom: -10px;
      color: #fff;
      font-size: 12px;
    }
  }
  &.active {
    border-color: #f9c158;
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: #f9c158;
    }
  }
}
.oth-wrap {
  position: relative;
  margin-top: 20px;
  text-align: center;
  color: #bcbcbc;
  border: 1px solid #ededed;
  .check {
    position: absolute;
    width: 0;
    height: 0;
    right: 0;
    bottom: 0;
    border: 14px solid #f9c158;
    border-top-color: transparent;
    border-left-color: transparent;
    border-right-width: 14px;
    .el-icon-check {
      position: absolute;
      bottom: -10px;
      color: #fff;
      font-size: 12px;
    }
  }
  &.is-active {
    border-color: #f9c158;
    color: #f9c158;
    input {
      color: #f9c158;
    }
    .gift-count {
        color: #FFFFFF;
        background: #f9c158;
      }
  }
  .error-tip {
    position: absolute;
    bottom: -20px;
    color: #FF4D01;
  }
}
.qr-wrap {
  padding: 20px;
  width: 176px;
  height: 176px;
  background: #fff;
  border: 1px solid #ededed;
}
.el-radio {
  line-height: 28px;
  /deep/ .el-radio__input {
    display: none;
  }
  /deep/ .el-radio__label {
    padding-left: 0;
  }
}
.oth-inp {
  padding: 5px 0;
  width: 100%;
  border: none;
  outline: none;
  // line-height: 35px;
  line-height: 50px;
  text-align: center;
  color: #bcbcbc;
  &::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #bcbcbc;
    font-size: 16px;
  }
  &::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #bcbcbc;
    font-size: 16px;
  }
  &:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #bcbcbc;
    font-size: 16px;
  }
}
.el-dialog__wrapper /deep/ .el-dialog.el-dialog--center {
  border-radius: 20px;
  .el-dialog__header {
    padding: 5px;
  }
  .el-dialog__footer {
    padding-bottom: 46px;
  }
}
.loading-pay.el-dialog__wrapper /deep/ .el-dialog {
  border-radius: 5px;
  .el-dialog__headerbtn {
    top: 15px;
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .el-dialog__footer {
    text-align: right;
    padding-bottom: 10px;
  }
}
.wechat-pay.el-dialog__wrapper /deep/ .el-dialog {
  border-radius: 20px;
  .el-dialog__header {
    padding: 40px 40px 0 40px;
    .el-dialog__headerbtn {
      top: 40px;
      right: 40px;
      width: 20px;
      height: 20px;
      border-radius: 30px;
      color: #bcbcbc;
      font-weight: bold;
      font-size: 14px;
      border: 1.5px solid #bcbcbc;
    }
  }
  .el-dialog__body {
    padding: 30px 40px;
  }
  .el-dialog__footer {
    padding-bottom: 0;
  }
}
.cancel-button {
  background: #eeeeee;
  color: #bcbcbc;
  border: none;
  height: 50px;
}
.dialog-l-tit {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.loading-model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2002;
  .el-icon-close {
    position: absolute;
    right: 40px;
    top: 20px;
    padding: 5px;
    font-size: 20px;
    color: rgba(252, 252, 252, 0.61);
    border: 2px solid rgba(252, 252, 252, 0.61);
    border-radius: 50px;
    cursor: pointer;
  }
  .loading-tip {
    position: absolute;
    top: 46%;
    left: 49%;
    color: #FF4D01;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/components/pay-dialog.vue